import { useNosIdMutation } from '@/hooks/api/base.hooks';
import { api, type SecurityCode, type ServiceAccountPin } from '@/portal-api.definition';
import { getAccountPinsQueryOptions } from '../../(pins)/-hooks/pins.hooks';
import { ActionType, useI18n, useToast } from '@nosinovacao/nosid-mfe-common';

export function useUpdatePins() {
  const toast = useToast();
  const { t } = useI18n();
  return useNosIdMutation({
    mutationFn: ({
      id,
      pins,
      securityCode,
    }: {
      id: string;
      type: string;
      pins: ServiceAccountPin[];
      securityCode: SecurityCode;
    }) => {
      return api.post(
        '/api/v2/services/pins/:serviceId',
        { SecurityCode: securityCode, Pins: pins },
        { params: { serviceId: id } },
      );
    },
    successLogAction: () => ({ ActionType: ActionType.Submit }),
    errorLogAction: () => ({ ActionType: ActionType.Submit }),
    onSuccess: (_, { id, type, pins }, __, { client }) => {
      client.setQueryData(getAccountPinsQueryOptions(id).queryKey, pins);
      const typeTranslation = t(`Pins.Type.${type}`);
      toast.show('success', t('Common.SnackBar.PinUpdated', { type: typeTranslation }));
    },
  });
}
